<template>
  <transition
    name="fade"
    mode="out-in"
  >
    <div class="my-car-view">
      <div class="header-wrapper">
        <dashboard-header
          text="Mój samochód"
          :has-slot="true"
        />
        <p>Informacje o Twoim samochodzie</p>
      </div>
      <div class="my-car-info">
        <car-block
          :car="myCar"
          mode="inner"
        />
      </div>
      <div class="my-car-visits">
        <template v-if="availableNextVisits">
          <p>
            Lista Twoich zbliżających się wizyt:
          </p>
          <visit-block
            v-for="(visit, index) in nextVisits"
            class="my-car-visit"
            :visit="visit"
            :car="myCar"
            :show-car-block="false"
            type="next"
            :key="'next' + index"
          />
        </template>
        <template v-if="availableHistoryVisits">
          <p>
            List Twoich poprzednich wizyt:
          </p>
          <visit-block
            v-for="(visit, index) in visibleHistoryVisits"
            class="my-car-visit"
            :visit="visit"
            :car="myCar"
            :show-car-block="false"
            type="history"
            :key="'history' + index"
          />
          <div class="show-all-element">
            <a
              href="#"
              v-if="historyVisits.length - historyVisitsNumber > 0"
              class="show-all-link-button"
              @click.prevent="showAll()"
            >
              pokaż wszystkie ({{ historyVisits.length - historyVisitsNumber }})
            </a>
          </div>
        </template>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardHeader from '~/DashboardHeader';
import CarBlock from '~/CarBlock';
import VisitBlock from '~/VisitBlock';
import dayjs from 'dayjs';

export default {
  components: {
    DashboardHeader,
    CarBlock,
    VisitBlock,
  },
  data() {
    return {
      historyVisitsNumber: 3,
    };
  },
  computed: {
    ...mapGetters({
      allCars: 'myCars/getMyCars',
      primaryColor: 'brand/getPrimaryColor',
    }),
    carID() {
      return this.$route.params.id;
    },
    myCar() {
      // eslint-disable-next-line
      return this.allCars.find(car => car.id == this.carID) || {};
    },
    historyVisits() {
      if (this.myCar.visits !== undefined && this.myCar.visits.length) {
        return this.myCar.visits.filter(visit => dayjs(visit.date).isBefore(dayjs()));
      }
      return null;
    },
    nextVisits() {
      if (this.myCar.visits !== undefined && this.myCar.visits.length) {
        return this.myCar.visits.filter(visit => dayjs(visit.date).isAfter(dayjs()));
      }
      return null;
    },
    visibleHistoryVisits() {
      return this.historyVisits.slice(0, this.historyVisitsNumber);
    },
    availableNextVisits() {
      if (this.nextVisits !== null) {
        return !!this.nextVisits.length;
      }
      return false;
    },
    availableHistoryVisits() {
      if (this.nextVisits !== null) {
        return !!this.historyVisits.length;
      }
      return false;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/dashboard/mycars' });
    },
    showAll() {
      this.historyVisitsNumber = this.historyVisits.length;
    },
  },
};
</script>
